import Vue from "vue";
import store from './index';

const state = {
	tabs: [
		// {
		// 	id: 0,
		// 	Name: "Вход",
		// 	Value: "home",
		// 	Route: "home",
		// 	Pagination: false
		// },
		{
			id: 0,
			Name: "Список заявок ",
			Value: "tickets",
			Route: "tickets",
			Pagination: true
		}
		// {
		// 	id: 2,
		// 	Name: "Архив заявок ",
		// 	Value: "archive",
		// 	Route: "archive",
		// 	Pagination: false
		// }
	], //массив для хранения объектов открытых вкладок
	numberOfFirstTab: 1, //следующий номер после номера последней статической вкладки state.tabs
	tickets: [], // массив для хранения всех заявок аптеки, используется для защиты от показа заявок других аптек
	priorities: [], //массив для хранния приоритетов заявок
	// customer: "501", //npp из таблицы COMPANYS
	//agent: "167", // аутентифицированный в системе пользователь, на период разработки Македонов В.А., затем надо будет получать из блока авторизации
	openedTicketsTabs: [], //хранилище для номеров заявок которые открыты во вкладках, защита от дублей открытых вкладок
	countMutation: 0,
	CurrentTabId: 0, // id текущей активной вкладки
	// agents: [],
	ticketsStates: [], // массив для хранения статусов заявок
	// ticketsClients: [], //массив для хранения списка аптек, планировалось использовать для фильтрации заявок по аптекам, в клиентской части не используется
	apteka: [], //объект аутентифицировавшейся аптеки
	ticketsWithChanges: [], // массив объектов всех заявок с изменениями
	ticketsWithUserMessages: [], // массив заявок в которых участвует пользователь (т.е. заявки в которых есть сообщение от пользователя)
	user: [], //объект пользователя сайта аптеки под которым выполнен вход
	siteUsers: [], //массив объектов пользователей сайта аптеки
	userId: 0, //id пользователя сайта под которым выполнен вход
	knownFileTypes: ['doc', 'docx', 'xls', 'xlsx', 'zip', 'pdf', 'ppt', 'pptx', 'txt', 'bmp', 'jpg', 'js', 'css', 'xml', 'sql', 'tif', 'html', 'gif', 'png', 'php', 'dmg'], //svg иконки в /dist/svg
	dataBaseVersion: 'production',
	appServerVersion: Object.create(null),
	appBuildVersion: {version: '0.0.50', date: '30.07.2026'},
	companys: [], // список всех клиентов из таблицы Companys - используется в компоненте messages.vue для распознавания email клиентов
	loginUsers: [],
	isResponseRequestTickets: [], // заявки для которых нужно вывести уведомление `Сотрудник Кверти запросил ответ на заявки №...'
	userTicketsWithChanges: [], // заявки пользователя для которых нужно вывести уведомление 'Новое сообщение в заявках №...'
	isRunInFz: localStorage.getItem('isRunInFz') || 'false',
	isSiteNeedReload: false
};

const getters = {
	NEWTABTICKETTITLE: state => {
		try {
			return JSON.parse(localStorage.newTabTicketTitle)
		} catch (error) {
			return {titleName: '', titleNpp: 0};
		}
	},
	SUPPORTTABS: state => {
		return state.tabs;
	},
	SUPPORTCURRENTPAGINATION: state => param_id => {
		let idx = state.tabs.findIndex(x => x.Route === param_id); // param_id = this.$route.params.id
		if (idx === -1) {
			//Default if not found in route
			return false;
		}
		return state.tabs[idx].Pagination;
	},
	SUPPORTCURRENTTAB: state => param_id => {
		//определяем какой компонент будем загружать
		let idx = state.tabs.findIndex(x => x.Route === param_id);
		if (idx === -1) {
			//Default if not found in route
			console.log(
				"Нет компонента в массиве вкладок, загружен компонент - NotFound"
			);
			return "NotFound";
		}
		return state.tabs[idx].Value;
	},
	SUPPORTCURRENTTABROUTE: state => {
		if (state.countMutation < 0) {
			return "never happen";
		}
		let route = "unknown";
		let storage = localStorage.SupportTab;
		if (storage) {
			route = storage;
		}
		let idx = state.tabs.findIndex(x => x.Route === route);
		if (idx === -1) {
			route = state.tabs[0].Route;
		}
		return "/support/" + route;
	},
	CURRENTTABID: state => {
		return state.CurrentTabId;
	},
	LAST_NUMBER: state => {
		return state.numberOfFirstTab;
	},
	TICKETS: state => {
		return state.tickets;
	},
	PRIORITIES: state => {
		return state.priorities;
	},
	// CUSTOMER: state => {
	// 	return state.customer;
	// },
	// AGENT: state => {
	// 	return state.agent;
	// },
	OPENEDTICKETSTABS: state => {
		return state.openedTicketsTabs;
	},
	// AGENTS: state => {
	// 	return state.agents;
	// },
	TICKETSSTATES: state => {
		return state.ticketsStates;
	},
	// TICKETSCLIENTS: state => {
	// 	return state.ticketsClients;
	// },
	CURRENTAPTEKA: state => {
		return state.apteka;
	},
	TICKETSWITHCHANGES: state => {
		return state.ticketsWithChanges;
	},
	// TICKETSWITHUSERMESSAGES: state => {
	// 	return state.ticketsWithUserMessages;
	// },
	CURRENTUSER: state => {
		return state.user;
	},
	SITEUSERS: state => {
		return state.siteUsers;
	},
	USERID: state => {
		return state.userId;
	},
	KNOWNFILETYPES: state => {
		return state.knownFileTypes;
	},
	DATABASEVERSION: state => {
		return state.dataBaseVersion;
	},
	APPBUILDVERSION: state => {
		return state.appBuildVersion;
	},
	APPSERVERVERSION: state => {
		return state.appServerVersion;
	},
	COMPANYS: state => {
		return state.companys;
	},
	LOGINUSERS: state => {
		return state.loginUsers;
	},
	ISRESPONSEREQUESTTICKETS: state => {
		return state.isResponseRequestTickets;
	},
	USERTICKETSWITHCHANGES: state => {
		return state.userTicketsWithChanges;
	},
	ISRUNINFZ: state => {
		return state.isRunInFz;
	},
	ISSITENEEDRELOAD: state => {
		return state.isSiteNeedReload;
	}
};

const mutations = {
	SETSUPPORTCURRENTTABROUTE: (state, data) => {
		if (data == null) {
			return;
		}
		localStorage.SupportTab = data.toString();
		state.countMutation++;
	},
	ADDTAB: (state, data) => {
		state.tabs.push(data);
	},
	SETNEWTABTICKETTITLE: (state, data) => {
		localStorage.newTabTicketTitle = JSON.stringify(data);
	},
	CLOSETAB: (state, data) => {
		state.tabs.splice(data, 1);
	},
	INCREASE__LAST__NUMBER: state => {
		state.numberOfFirstTab++;
	},
	SET__TICKETS: (state, data) => {
		state.tickets = data;
	},
	SET__PRIORITIES: (state, data) => {
		state.priorities = data;
	},
	SETCURRENTTABID: (state, data) => {
		state.CurrentTabId = data;
	},
	ADDOPENEDTICKETSTABS: (state, data) => {
		state.openedTicketsTabs.push(data);
	},
	REMOVEOPENEDTICKETSTABS: (state, data) => {
		state.openedTicketsTabs.splice(data, 1);
	},
	// SETAGENTS: (state, data) => {
	// 	state.agents = data;
	// },
	SETTICKETSSTATES: (state, data) => {
		state.ticketsStates = data;
	},
	// SETTICKETSCLIENTS: (state, data) => {
	// 	state.ticketsClients = data;
	// },
	SETCURRENTAPTEKA: (state, data) => {
		state.apteka = data;
	},
	ADDTICKETSWHITHCHANGES: (state, data) => {
		state.ticketsWithChanges.push(data);
	},
	// ADDTICKETSWITHUSERMESSAGES: (state, data) => {
	// 	state.ticketsWithUserMessages.push(data);
	// },
	REMOVETICKETSWHITHCHANGES: (state, data) => {
		state.ticketsWithChanges.splice(data, 1);
	},
	SETTICKETSWHITHCHANGES: (state, data) => {
		state.ticketsWithChanges = data;
	},
	// SETTICKETSWITHUSERMESSAGES: (state, data) => {
	// 	state.ticketsWithUserMessages = data;
	// },
	SETCURRENTUSER: (state, data) => {
		state.user = data;
	},
	SETSITEUSERS: (state, data) => {
		state.siteUsers = data;
	},
	SETUSERID: (state, data) => {
		state.userId = data;
	},
	SETDATABASEVERSION: (state, data) => {
		state.dataBaseVersion = data;
	},
	SETAPPSERVERVERSION: (state, data) => {
		state.appServerVersion = data;
	},
	SETCOMPANYS: (state, data) => {
		state.companys = data;
	},
	SETLOGINUSERS: (state, data) => {
		state.loginUsers = data;
	},
	SETISRESPONSEREQUESTTICKETS: (state, data) => {
		state.isResponseRequestTickets = data;
	},
	SETUSERTICKETSWITHCHANGES: (state, data) => {
		state.userTicketsWithChanges = data;
	},
	ADDUSERTICKETSWITHCHANGES: (state, data) => {
		if (!state.userTicketsWithChanges.includes(data)) {
			state.userTicketsWithChanges.push(data);
		}
	},
	REMOVEUSERTICKETSWITHCHANGES: (state, data) => {
		if (!data) console.error(`ERROR in mutation REMOVEUSERTICKETSWITHCHANGES: data is null`);
		state.userTicketsWithChanges = state.userTicketsWithChanges.filter(x => +x !== +data);
	},
	SETISRUNINFZ: (state, data) => {
		state.isRunInFz = data;
		localStorage.setItem('isRunInFz', data);
	},
	SETISSITENEEDRELOAD: (state, data) => {
		state.isSiteNeedReload = data;
	}
};

const actions = {
	SET_SUPPORTCURRENTTABROUTE: (context, data) => {
		context.commit("SETSUPPORTCURRENTTABROUTE", data);
	},
	ADD_TABB: (context, data) => {
		context.commit("ADDTAB", data);
		localStorage.openedTabs = JSON.stringify(state.tabs);
	},
	SETNEWTABTICKETTITLEA: (context, data) => {
		context.commit("SETNEWTABTICKETTITLE", data);
	},
	CLOSE_TABB: (context, data) => {
		context.commit("CLOSETAB", data);
		localStorage.openedTabs = JSON.stringify(state.tabs);
	},
	INCREASE_LAST_NUMBER: context => {
		context.commit("INCREASE__LAST__NUMBER");
	},
	GET_TICKETS: (context, data) => {
		Vue.http
			.get("data/GetClientTickets", {
				params: {apteka_npp: data}
			})
			.then(
				response => {
					context.commit("SET__TICKETS", response.body);
				},
					error => {
					console.log(error);
				}
			);
	},
	GET_PRIORITIES: (context, payload) => {
		Vue.http.get("data/getpriorities").then(
			response => {
				context.commit("SET__PRIORITIES", response.body);
			},
			error => {
				console.log(error);
			}
		);
	},
	SET_CURRENTTABID: (context, data) => {
		context.commit("SETCURRENTTABID", data);
	},
	ADD_OPENEDTICKETSTABS: (context, data) => {
		context.commit("ADDOPENEDTICKETSTABS", data);
	},
	REMOVE_OPENEDTICKETSTABS: (context, data) => {
		context.commit("REMOVEOPENEDTICKETSTABS", data);
	},
	// GET_AGENTS: (context, payload) => {
	// 	Vue.http.get("data/getAgents").then(
	// 		response => {
	// 			context.commit("SETAGENTS", response.body);
	// 		},
	// 		error => {
	// 			console.log(error);
	// 		}
	// 	);
	// },
	GET_TICKETS_STATES: (context, payload) => {
		Vue.http.get("data/getStates").then(
			response => {
				context.commit("SETTICKETSSTATES", response.body);
			},
			error => {
				console.error(error);
			}
		);
	},
	// GET_TICKETS_CLIENTS: (context, payload) => {
	// 	Vue.http.get("data/getClients").then(
	// 		response => {
	// 			context.commit("SETTICKETSCLIENTS", response.body);
	// 		},
	// 		error => {
	// 			console.error(error);
	// 		}
	// 	);
	// },
	SET_CURRENTAPTEKA: (context, data) => {
		context.commit("SETCURRENTAPTEKA", data);
	},
	ADD_TICKETSWHITHCHANGES: (context, data) => {
		if (!state.ticketsWithChanges.find(x => x.npp === data.npp)) {
			context.commit("ADDTICKETSWHITHCHANGES", data);
		}
	},
	// ADD_TICKETSWITHUSERMESSAGES: (context, data) => {
	// 	if (!state.ticketsWithUserMessages.includes(data)) {
	// 		context.commit("ADDTICKETSWITHUSERMESSAGES", data);
	// 	}
	// },
	REMOVE_TICKETSWHITHCHANGES: (context, data) => {
		context.commit("REMOVETICKETSWHITHCHANGES", data);
		// localStorage.setItem(`ticketsWithChanges_${state.apteka.idapt}`, JSON.stringify(state.ticketsWithChanges));
	},
	SET_TICKETSWHITHCHANGES: (context, data) => {
		context.commit("SETTICKETSWHITHCHANGES", data);
	},
	// SET_TICKETSWITHUSERMESSAGES: (context, data) => {
	// 	context.commit("SETTICKETSWITHUSERMESSAGES", data);
	// },
	SET_TICKETLASTUPDATETIME: (context, data) => {
		const params = {
			ticketNpp: data.ticketNpp,
			clientNpp: data.clientNpp,
			userId: data.userId
		};
		if (!params.ticketNpp) {
			return;
		}
		Vue.http.put("data/SetTicketLastUpdateTime", params, {emulateJSON: true}).then(
			() => {

			},
			error => {
				console.error(error);
				Vue.store.dispatch("showSnackBar", {
					snackText: `Ошибка при обновлении времени последнего просмотра заявки ${data.ticketNpp}`
				});
			}
		);
	},
	// SET_LASTUPDATETIMEFROMSERVER: (context, data) => {
	// 	const params = {
	// 		clientNpp: data.clientNpp,
	// 		userId: data.userId
	// 	};
	// 	Vue.http.put("data/SetLastUpdateTimeFromServer", params, {emulateJSON: true}).then(
	// 		() => {
	//
	// 		},
	// 		error => {
	// 			console.error(error);
	// 			Vue.store.dispatch("showSnackBar", {
	// 				snackText: `Ошибка при обновлении времени последних изменений`
	// 			});
	// 		}
	// 	);
	// },
	SET_CURRENTUSER: (context, data) => {
		context.commit("SETCURRENTUSER", data);
	},
	SET_USERID: (context, data) => {
		context.commit("SETUSERID", data);
	},
	GET_SITEUSERS: async (context, data) => {
		Vue.http.get("data/GetSiteUsers", {
			params: {aptekaId: data}
		}).then(
			response => {
				context.commit("SETSITEUSERS", response.body);
				return Promise.resolve(response.body);
			},
			error => {
				console.error(error);
				return Promise.reject(error);
			}
		);
	},
	GET_DATABASEVERSION: (context, data) => {
		Vue.http.get("data/GetDataBaseVersion").then(
			response => {
				context.commit("SETDATABASEVERSION", response.body);
			},
			error => {
				console.error(error);
			}
		);
	},
	GET_APPVERSION: async ({commit}, data) => {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await Vue.http.get("data/GetAppVersion");
				commit("SETAPPSERVERVERSION", response.body[0]);
				resolve(response.body[0]);
			} catch (error) {
				console.error(error);
				store.dispatch('showSnackBar', {snackText: error.message});
				commit("SETAPPSERVERVERSION", Object.create(null));
				reject(Object.create(null));
			}
		});
	},
	GET_COMPANYS: async ({commit}, data) => {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await Vue.http.get("data/GetCompanys");
				commit("SETCOMPANYS", response.body);
				resolve(response.body);
			} catch (error) {
				console.error(error);
				store.dispatch('showSnackBar', {snackText: error.message});
				commit("SETCOMPANYS", []);
				reject([]);
			}
		});
	},
	GET_LOGINUSERS: async ({commit}, data) => {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await Vue.http.get("data/GetLoginUsers");
				commit("SETLOGINUSERS", response.body);
				resolve(response.body);
			} catch (error) {
				console.error(error);
				store.dispatch('showSnackBar', {snackText: error.message});
				commit("SETLOGINUSERS", []);
				reject([]);
			}
		});
	},
	SET_ISRESPONSEREQUESTTICKETS: ({commit}, data) => {
		commit("SETISRESPONSEREQUESTTICKETS", data);
	},
	SET_USERTICKETSWITHCHANGES: ({commit}, data) => {
		commit("SETUSERTICKETSWITHCHANGES", data);
	},
	ADD_USERTICKETSWITHCHANGES: ({commit}, data) => {
		commit("ADDUSERTICKETSWITHCHANGES", data);
	},
	REMOVE_USERTICKETSWITHCHANGES: ({commit}, data) => {
		commit("REMOVEUSERTICKETSWITHCHANGES", data);
	},
	SET_ISRUNINFZ: ({commit}, data) => {
		commit("SETISRUNINFZ", data);
	},
	SET_ISSITENEEDRELOAD: ({commit}, data) => {
		commit("SETISSITENEEDRELOAD", data);
	}
};

export default {
	state,
	getters,
	mutations,
	actions
};



// WEBPACK FOOTER //
// ./Components/store/mainsupport.js